import { useState } from 'react';
import ArrowRightIcon from '@liquidweb-dev/undercurrent/icons/lucide/ArrowRight';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import LWForm, { type FormSubmitHandler } from 'components/LWForm';
import HookedSubmit from 'components/standard/Form/HookedSubmit';
import HookedCheckboxSimple from 'components/standard/Form/HookedCheckbox';
import { type CancellationFormData } from './constants';

export interface LastServerCleanupProps {
	formValues: CancellationFormData;
	onFormValuesChange: (values: CancellationFormData) => void;
	onSubmit: FormSubmitHandler<CancellationFormData>;
}

const LastServerCleanup = ({
	formValues,
	onFormValuesChange,
	onSubmit,
}: LastServerCleanupProps) => {
	const [formErrors, setFormErrors] = useState({
		cleanup_assets: '',
	});

	return (
		<LWForm
			values={formValues}
			onValuesChange={onFormValuesChange}
			errors={formErrors}
			onErrorsChange={setFormErrors}
			onSubmit={onSubmit}
		>
			<Stack width="100%" direction="column" gap={400} useFlexGap>
				<Stack direction="column" gap={100} useFlexGap>
					<Typography fontWeight="500" variant="title-md">
						This is the last server on your account and a bit of additional
						clean up is required
					</Typography>
					<Typography variant="body-md">
						Since this is the last server on your account, you have the option
						to clean up any remaining services or data to avoid future charges
						or confusion.
					</Typography>
				</Stack>
				<Stack direction="column" gap={400}>
					<Stack direction="row" alignItems="flex-start" gap={150}>
						<HookedCheckboxSimple
							name="cleanup_assets"
							style={{ width: 24, height: 24 }}
							FormControlLabelProps={{
								style: { marginLeft: 0, marginRight: 0 },
							}}
						/>
						<Typography variant="body-md">
							Disable auto-renewal for all domain registrations and SSL
							certificates, and remove any remaining DNS zones on this account.
						</Typography>
					</Stack>

					<Stack alignItems="center">
						<HookedSubmit
							size="large"
							variant="primary"
							endIcon={<ArrowRightIcon />}
							sx={{ width: 200 }}
						>
							Next
						</HookedSubmit>
					</Stack>
				</Stack>
			</Stack>
		</LWForm>
	);
};

export default LastServerCleanup;
